import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";

// Rendered for any route React Router does not match, and prerendered to
// build/404.html so Firebase Hosting can serve a real 404 status instead of
// answering every URL on the domain with a 200 and the homepage shell.
export default function NotFound() {
  const links = [
    { to: "/services/pre-sale", label: "Pre-sale property inspections" },
    { to: "/pricing", label: "Pricing" },
    { to: "/service-areas/darwin", label: "Areas we cover" },
    { to: "/faq", label: "Frequently asked questions" },
    { to: "/contact", label: "Book an inspection" },
  ];

  return (
    <div>
      <Helmet>
        <title>Page Not Found | Aussie Inspections Darwin</title>
        <meta
          name="description"
          content="That page doesn't exist. Find building, pool and plumbing inspections in Darwin, Palmerston and Litchfield with Aussie Inspections."
        />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <section className="bg-primary text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-blue-200 font-semibold tracking-wide mb-3">404</p>
          <h1 className="font-chivo text-4xl md:text-5xl font-black tracking-tight leading-none mb-4">
            We couldn't find that page
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            It may have moved. Here's where most people are heading.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <ul className="space-y-3 mb-10">
            {links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="block rounded-lg border border-slate-200 px-5 py-4 text-slate-900 font-semibold hover:border-primary hover:text-primary transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="text-center">
            <Button asChild size="lg">
              <Link to="/">Back to home</Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
